import React, { useEffect } from 'react'
import styles from  './overview4.module.css'
import {Link, useNavigate} from 'react-router-dom'
const TOOLS=["HTML","CSS","JAVASCRIPT","EJS","Webpack", "Bootstrap","RESPONSIVE DESIGN"];

export default function Overview2() {
  const navigate=useNavigate();

  useEffect(()=>{
     window.scroll({top:0,behavior:"smooth"})
  },[])
  
  const navigateToProject=()=>{
    navigate('/project1')
  }

  const navigateToVideoPlatform=()=>{
    navigate('/project2')
  }

  return (
    <div className={styles.overview1}>
      <div className={styles.wrapper}>
        {/* <div className={styles["title-container"]}>
          <div className={styles["game-title"]}>Fashion Ecommerce</div>
        </div> */}
        <h3 className={styles.header}>Overview</h3>
        <p className={styles.overview}>
        Fashion Ecommerce website built with JavaScript EJS, webpack ,and Node.js. This website offers various
        useful features to find favourite outfits by keyword-based search, filtering, sorting. Users can
        check them in thier shopping cart before finizing their orders. STILL WORKING ON IMPROVEMENT. STAY TUNED
        </p>
        <div className={styles.tools}>
          {TOOLS.map((t,index)=>(
            <span className={styles.tool} key={index}>{t}</span>
          ))}
        </div>
        <div className={styles.devices}>
            <div className={styles["macbook-container"]}>
              <img src="./images/fashion-laptop.png" alt="" className={styles.macbook} />
              <img src="./images/fashion-phone.png" alt="" className={styles.phone}/>
              <img src="./images/fashion-ipad.png" alt="" className={styles.ipad}/>
            </div>
        </div>
        <h3 className={styles.header}>Design</h3>
        <div className={styles.gallery}>
          <video src="./images/ecommerce-rec.mp4" controls className={styles.video} playsInline muted autoPlay/>
          <video src="./images/ecommerce-mobile.mp4" controls className={styles.video2} playsInline muted autoPlay/>
        </div>
        <div className={styles.icons}>
            <a href="https://www.linkedin.com/in/ryo-aoyama-21392222b/"><img src="./images/linkedin2.png" alt="" className={styles.linkedin}/></a>
            <a href='https://github.com/RyoGitacc/webpack-ecommerce'><img src="./images/github-mark.png" alt="" className={styles.github}/></a>
        </div>
        <div className={styles['btn-container']}>
            <a href='https://stormy-tundra-83234-974f64c39645.herokuapp.com/'>
            <button className={styles.btn}>Visit Website</button>
            </a>
        </div>
        <h3 className={styles.header}>More Works</h3>
        <div className={styles["more-work"]}>
           <div className={styles.classified} onClick={navigateToProject}></div>
           <div className={styles.notyet} onClick={navigateToVideoPlatform}></div>
        </div>
        <p className={styles.back}>
          <Link to='/' className={styles.link}>
            Back to home
          </Link>
        </p>
      </div>
    </div>
  )
}
